"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Activity = void 0;

var _react = require("@lingui/react");

var React = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _core = require("@lingui/core");

var _context = require("../context");

var _Comment = require("../../../Action/components/Comment");

var _AddMessage = require("./AddMessage");

var Elements = _interopRequireWildcard(require("./Activity.styles"));

var _attachments = require("../../../../context/attachments");

const Activity = ({
  onNewCommentAdded
}) => {
  const {
    messageStatus,
    action,
    actionId,
    isOpen,
    messages
  } = (0, _context.useState)();
  const {
    loadMessages
  } = (0, _context.useActions)();
  const feedRef = React.useRef(null);
  const innerRef = React.useRef(null);
  const firstRender = React.useRef(true);
  React.useEffect(() => {
    if (actionId !== undefined && isOpen && messageStatus === _context.Status.idle) {
      void loadMessages(actionId);
    }
  }, [actionId, isOpen, messageStatus]);
  /**
   * On initial rendering of messages, scroll to the bottom
   * of the feed.
   * On subsequent renders (i.e., after commenting) scroll
   * to the bottom with a smooth animation.
   */

  React.useEffect(() => {
    if (feedRef.current !== null && innerRef.current !== null) {
      feedRef.current.scrollTo({
        top: innerRef.current.getBoundingClientRect().height,
        behavior: !firstRender.current ? 'smooth' : 'auto'
      }); // once the new comment is added, update the background action list

      if (action !== undefined) {
        onNewCommentAdded(action);
      }
    }

    if (messageStatus === _context.Status.ready) {
      firstRender.current = false;
    }
  }, [messages]);

  const handleRemoveComment = commentId => {
    if (actionId === undefined) return;
    if (!confirm(_core.i18n._({
      id: 'view_action_activity.remove_comment_confirmation_text'
    }))) return;
    void _axios.default.delete(`/v2/comments/${commentId}`).then(() => {
      void loadMessages(actionId);
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Elements.Wrapper, null, /*#__PURE__*/React.createElement(Elements.Title, null, /*#__PURE__*/React.createElement(_react.Trans, {
    id: "view_action_activity.column_title"
  })), messages !== undefined && messages.length > 0 && /*#__PURE__*/React.createElement(Elements.Feed, {
    ref: feedRef
  }, /*#__PURE__*/React.createElement("div", {
    ref: innerRef
  }, messages.map(m => /*#__PURE__*/React.createElement(_Comment.Comment, {
    key: m.comment_id,
    comment: m,
    onRemove: handleRemoveComment
  })))), messages !== undefined && messages.length === 0 && /*#__PURE__*/React.createElement(Elements.EmptyActivityWrapper, null, /*#__PURE__*/React.createElement(Elements.ChatIcon, {
    large: true
  }), /*#__PURE__*/React.createElement(_react.Trans, {
    id: "view_action_activity.no_activity_message",
    components: {
      0: /*#__PURE__*/React.createElement(Elements.EmptyActivityTitle, null),
      1: /*#__PURE__*/React.createElement(Elements.EmptyActivityTip, null)
    }
  })), /*#__PURE__*/React.createElement(Elements.Controls, null, actionId !== undefined && /*#__PURE__*/React.createElement(_attachments.AttachmentsProvider, null, /*#__PURE__*/React.createElement(_AddMessage.AddMessage, {
    actionId: actionId
  })))));
};

exports.Activity = Activity;